export class Bundle {
    id: number;
    name: string;
}
